
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class EANCodeService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getEANCodeByCustomer(customerId: number) {
        return this.http.get(`api/EANCode/GetEANCodeByCustomer/${customerId}`, this.getAuthHeader(true));
    }

    getEanCodesByCustomerAndEANCodeType(customerId: number, eanCodeTypeId: number, contractType: string) {
        return this.http.get(`api/EANCode/GetEanCodesByCustomerAndEANCodeType/${customerId}/${eanCodeTypeId}/${contractType}`, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get(`api/EANCode/Delete/${id}`, this.getAuthHeader(true));
    }

    exportExcel(ids: string, customerId: number) {
        return this.http.post(`/api/EANCode/ExportExcel`, { ids: ids, customerId: customerId }, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/ean-code.service.ts